// PageTransition — adds a brief slide-in / fade animation on every route
// change so navigation feels instant even when the underlying page is still
// fetching data.
//
// The wrapper:
//   • Listens to `useLocation()` and bumps a `key` whenever pathname changes.
//   • Renders children inside a div whose CSS animation re-runs on key change.
//   • iOS-style ease + ~180 ms duration → fast and unobtrusive.
//   • `prefers-reduced-motion` → instant (no animation, accessibility).

import { useLocation } from "react-router-dom";

const STYLES = `
@keyframes wing-page-slide {
    0%   { opacity: 0; transform: translateX(8px); }
    100% { opacity: 1; transform: translateX(0); }
}
.wing-page-anim {
    /* fill-mode "backwards" (NOT "both"/"forwards"): a lingering transform
       — even translateX(0) — turns this wrapper into the containing block
       for every position:fixed descendant. That trapped all bottom-sheets
       beneath the BottomNav and made them scroll with the page on iOS.
       After the 180ms slide the computed transform must return to "none". */
    animation: wing-page-slide 0.18s cubic-bezier(0.22, 1, 0.36, 1) backwards;
}
@media (prefers-reduced-motion: reduce) {
    .wing-page-anim { animation: none !important; }
}
`;

let injected = false;
function injectStyles() {
    if (injected || typeof document === "undefined") return;
    const tag = document.createElement("style");
    tag.setAttribute("data-wing", "page-transition");
    tag.textContent = STYLES;
    document.head.appendChild(tag);
    injected = true;
}

export default function PageTransition({ children }) {
    injectStyles();
    const { pathname } = useLocation();
    return (
        <div key={pathname} className="wing-page-anim">
            {children}
        </div>
    );
}
